'use strict';

/* ROVIAE global navigation — V26 */
(() => {
      const closeOtherNavigation = (event) => {
        const menu = document.querySelector('.rv-global-nav__mobile-menu');
        if (menu && menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      };
      document.addEventListener('click', closeOtherNavigation);
    })();
